module.exports = __webpack_public_path__ + "static/media/pause_preview.ba9fca31.svg";